// extracted by mini-css-extract-plugin
export var standaloneTable = "_gn-0";
export var standaloneTableWithBodyFill = "_gn-1";
export var withExtraHeader = "_gn-2";